import store from "../../../store";
import { IContentSource } from "../../../domain/drawing";
import { AbstractSource } from "../../drawing";
import { ImageSourceKinds, IDocumentImageSource } from "../../../domain/document";
import { IConfiguration } from "../../../domain/configuration";

export class ImageSource extends AbstractSource implements IDocumentImageSource {
  constructor(
    getToken: () => string,
    public formatId: number,
    public documentId: number,
    private _imageSourceKind: ImageSourceKinds,
    public imageGuid: string,
    public quotedFormatId?: number
  ) {
    super(getToken);
  }

  public get imageSourceKind(): ImageSourceKinds {
    return (this._imageSourceKind == null)
      ? ImageSourceKinds.None
      : this._imageSourceKind;
  }

  public set imageSourceKind(kind: ImageSourceKinds) {
    this._imageSourceKind = kind;
    if (kind !== ImageSourceKinds.Document) {
      this.documentId = null;
    }
    if (kind !== ImageSourceKinds.Format) {
      this.formatId = null;
    }
  }

  protected getSource(): string {
    // TODO:画像をキャッシュするならここで実装する.とりあえずはソース文字列を返す.
    // TODO:ブラウザの画像が無いアイコンを表示させないようにするには、画像の有無をあらかじめ判定して返却して、空のURLで返すなどの対策が必要.
    // ->画像が無い場合はバックエンドから縦横1pxのダミー画像を返却するように暫定対応済み
    if (this.imageSourceKind === ImageSourceKinds.Cache) {
      return this.createCachedImageSourceUrl();
    }
    if (this.imageSourceKind === ImageSourceKinds.Document) {
      return this.createRegisteredImageSourceUrl();
    }
    if (this.imageSourceKind === ImageSourceKinds.Format) {
      return this.createFormatImageSourceUrl();
    }
    return null;
  }

  createCachedImageSourceUrl(): string {
    if (!this.imageGuid) {
      console.error("アップロードした画像の読み込みに失敗しました。imageGuid: " + this.imageGuid);
      return "InvalidUrl";
    }
    return "/api/document/temporary/image/" + this.imageGuid + "?token=" + this.token;
  }

  createRegisteredImageSourceUrl(): string {
    if (this.documentId === null || this.documentId === undefined) {
      console.error("文書の画像の読み込みに失敗しました。documentId: " + this.documentId);
      return "InvalidUrl";
    }
    return "/api/document/" + this.documentId + "/image/" + this.imageGuid + "?token=" + this.token;
  }

  createFormatImageSourceUrl(): string {
    const config = store.getters.configuration as IConfiguration;
    if (this.formatId !== null && this.formatId !== undefined) {
      return "/api/format/" + this.formatId + "/image/" + this.imageGuid + "?token=" + this.token;
    } else if (this.quotedFormatId !== null && this.quotedFormatId !== undefined) {
      return "/api/format/" + this.quotedFormatId + "/image/" + this.imageGuid + "?token=" + this.token;
    } else {
      console.error(config.wording.format.attributes.name + "の画像の読み込みに失敗しました。formatId: " + this.formatId);
      return "InvalidUrl";
    }
  }

  public clone(): IContentSource {
    return new ImageSource(
      this._getToken,
      this.formatId,
      this.documentId,
      this.imageSourceKind,
      this.imageGuid,
      this.quotedFormatId
    );
  }
}
